import React from 'react';
import { Link } from 'react-router-dom';
import { HeroSection } from '../components/landing/HeroSection';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSection } from '../components/landing/SolutionSection';
import { GeniusesSection } from '../components/landing/GeniusesSection';
import { IncludesSection } from '../components/landing/IncludesSection';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { AudienceSection } from '../components/landing/AudienceSection';
import { OfferSection } from '../components/landing/OfferSection';
import { FinalCTASection } from '../components/landing/FinalCTASection';
export function LandingPage() {
  return <div className="min-h-screen flex flex-col w-full" data-id="element-122">
      <HeroSection data-id="element-123" />
      <ProblemSection data-id="element-124" />
      <SolutionSection data-id="element-125" />
      <GeniusesSection data-id="element-126" />
      <IncludesSection data-id="element-127" />
      <BenefitsSection data-id="element-128" />
      <AudienceSection data-id="element-129" />
      <OfferSection data-id="element-130" />
      <FinalCTASection data-id="element-131" />

      <footer className="bg-[#2A180D] text-[#E0D8D0] py-12 text-center border-t border-[#3D2314]" data-id="element-132">
        <div className="max-w-7xl mx-auto px-4" data-id="element-133">
          <p className="font-serif text-xl mb-4" data-id="element-134">
            Genios que Transformaron la Humanidad
          </p>
          <p className="text-sm opacity-60 mb-6" data-id="element-135">
            © 2026 Digital Audible Editorial. Todos los derechos reservados.
          </p>
          <div className="flex justify-center gap-6 text-sm" data-id="element-136">
            <Link to="/privacidad" className="text-[#C9A227] hover:text-[#E0D8D0] transition-colors" data-id="element-137">
              Política de Privacidad
            </Link>
            <span className="text-[#E0D8D0]/30" data-id="element-138">|</span>
            <Link to="/terminos" className="text-[#C9A227] hover:text-[#E0D8D0] transition-colors" data-id="element-139">
              Términos de Servicio
            </Link>
          </div>
        </div>
      </footer>
    </div>;
}